export default [
  {
    date: 1445438181081,
    row: 7,
    col: 11,
    segments: [
      [6, 1, 3, 2],
      [3, 2, 2, 4],
      [2, 4, 4, 6],
      [4, 6, 8, 6],
      [8, 6, 10, 4],
      [10, 4, 9, 2],
      [9, 2, 6, 1]
    ]
  },
  {
    date: 1445438181081,
    row: 7,
    col: 11,
    segments: [[2, 3, 5, 1], [5, 1, 11, 3], [11, 3, 5, 5], [5, 5, 2, 3]]
  },
  {
    date: 1490130909810,
    row: 7,
    col: 11,
    segments: [
      [2, 4, 4, 4],
      [4, 4, 5, 3],
      [5, 3, 7, 2],
      [7, 2, 9, 2],
      [9, 2, 10, 3],
      [10, 3, 9, 4],
      [9, 4, 7, 5],
      [7, 5, 5, 5],
      [5, 5, 4, 4],
      [4, 4, 3, 6],
      [3, 6, 3, 5],
      [3, 5, 2, 4],
      [5, 3, 4, 2],
      [4, 2, 6, 2],
      [6, 2, 7, 2],
      [7, 5, 6, 6],
      [6, 6, 5, 6],
      [5, 6, 6, 5],
      [9, 4, 8, 4]
    ]
  }
];
